import crud from "../../../crud";


crud.conf['w-custom'] = {
}

const vCustomMixin = {

}
export default vCustomMixin
